import {
  IconAdvisor,
  IconBenefit,
  IconDifferenttype,
  IconFamily,
  IconFree,
  IconKid,
  IconMoneyplus,
} from "@manifesthhqinc/ui-library";
import FuturemoneyLogo from "../assets/provider-logos/future-money.png";
import BettermentLogo from "../assets/provider-logos/betterment-color.png";
import { ProviderContent } from "../class/iraQuestionnaire";
import RobinhoodLogo from "../assets/provider-logos/robinhood.png";
import SoFiLogo from "../assets/provider-logos/SoFiLogo.png";

export const getProviderContent = (providerName: string): ProviderContent => {
  switch (providerName) {
    case "FUTURE_MONEY":
    case "FutureMoney":
    case "Futuremoney":
      return {
        providerName: "Futuremoney",
        logo: FuturemoneyLogo,
        descriptionMain:
          "This option is ideal for the investors who have long-term family financial goals, like saving for your children’s future.",
        description:
          "This option is ideal for the investors who have long-term family financial goals, like saving for your children’s future.",
        hereIsWhy: [
          {
            icon: <IconFamily color="dark" size="large" />,
            text: "Invest together with accounts for couples and families included",
          },
          {
            icon: <IconKid color="dark" size="large" />,
            text: "The only provider to offer the Junior Roth IRA for kids",
          },
          {
            icon: <IconFree color="dark" size="large" />,
            text: "Manifest exclusive: No subscription fees",
          },
        ],
        standoutFeatures: [
          {
            heading: "Professional Advice with Low Fees",
            description:
              "Get the best of both worlds with a fully managed account, access to a dedicated investment advisor, and a competitive management fee of 0.25%.",
          },
          {
            heading: "Focus on Tax-Advantaged Accounts",
            description:
              "Offers a comprehensive selection of tax- advantaged accounts to keep more money in your pocket.",
          },
        ],
        whoItsBestFor: [
          {
            heading: "Family-Oriented Investors",
            description: "Ideal for family-focused goals and investors with a commitment to retirement.",
          },
          {
            heading: "Mobile Users",
            description: "Designed for app-based investing with on- the-go accessibility.",
          },
        ],
        otherConsiderations: [
          {
            heading: "Limited Investment Options",
            description:
              "Primarily focuses on fully-managed portfolios, which may not appeal to investors seeking a wide range of investment choices.",
          },
        ],
        additionalBenefits: [
          {
            heading: "Easy Account Opening",
            description: "Thanks to our partnership, Manifest can handle the account setup for you.",
          },
          {
            heading: "No Subscription Fees",
            description: "Manifest users have receive additional benefits, including no subscription fees.",
          },
        ],
      };
    case "BETTERMENT":
    case "Betterment":
      return {
        providerName: "Betterment",
        logo: BettermentLogo,
        descriptionMain:
          "Betterment IRA is best for hands-off investors seeking automated portfolio management, tax-efficient strategies, and occasional access to advisors.",
        description:
          "Manifest has carefully reviewed your options and recommends Betterment for investors who value automated portfolio management, tools for retirement planning, and access to financial advisors (minimum balance required).",
        hereIsWhy: [
          {
            icon: <IconDifferenttype color="dark" size="large" />,
            text: "Offers tools to create personalized plans",
          },
          {
            icon: <IconBenefit color="dark" size="large" />,
            text: "Employs automated tax-saving strategies, e.g., tax-loss harvesting",
          },
          {
            icon: <IconAdvisor color="dark" size="large" />,
            text: "Access to financial advisors (minimum balance required)",
          },
        ],
        standoutFeatures: [
          {
            heading: "Automated Tax Strategies",
            description:
              "Betterment employs automated tax-saving strategies, such as tax-loss harvesting, to help minimize your tax liabilities and enhance after-tax returns. ",
          },
          {
            heading: "Personalized Planning Tools",
            description:
              "Betterment offers tools to create customized retirement plans, helping users set and track financial goals.",
          },
        ],
        whoItsBestFor: [
          {
            heading: "Hands-Off Investors",
            description: "Ideal for those who want automated portfolio management with minimal effort.",
          },
          {
            heading: "New Investors",
            description: "Beginner-friendly for new investors with no account minimums and low fees.",
          },
        ],
        otherConsiderations: [
          {
            heading: "Limited Investment Options",
            description:
              "Primarily focuses on fully-managed portfolios, which may not appeal to investors seeking a wide range of investment choices.",
          },
        ],
      };
    case "ROBINHOOD":
    case "Robinhood":
      return {
        providerName: "Robinhood",
        logo: RobinhoodLogo,
        descriptionMain:
          "This option is ideal for tech-savvy investors seeking a low-cost platform with commission-free trading and IRA match benefits.",
        description:
          "Manifest has carefully reviewed your options and recommends Robinhood for its simple, low-cost investment solutions and trusted reputation in the financial industry.",
        hereIsWhy: [
          {
            icon: <IconBenefit color="dark" size="large" />,
            text: "Robinhood offers a 1% match on all IRA contributions",
          },
          {
            icon: <IconMoneyplus color="dark" size="large" />,
            text: "Contributions up to $1,000 are available for immediate investment",
          },
          {
            icon: <IconDifferenttype color="dark" size="large" />,
            text: "Robinhood provides personalized portfolio suggestions",
          },
        ],
        standoutFeatures: [
          {
            heading: "IRA Match",
            description: "Robinhood offers a 1% match on all IRA contributions, transfers, and rollovers, with no cap.",
          },
          {
            heading: "Portfolio Recommendations",
            description:
              "Robinhood provides personalized portfolio suggestions to help investors make informed decisions aligned with their financial goals.",
          },
        ],
        whoItsBestFor: [
          {
            heading: "Tech-Savvy Users",
            description: "Those who prefer a user-friendly, mobile-first platform for managing investments.",
          },
          {
            heading: "Cost-Conscious Investors",
            description: "Individuals seeking commission-free trading with",
          },
        ],
        otherConsiderations: [
          {
            heading: "Limited Investment Options",
            description:
              "Robinhood does not offer mutual funds or bonds, which may not meet the needs of investors seeking a diversified portfolio.",
          },
        ],
      };
    case "SOFI":
    case "SoFi":
      return {
        providerName: "SoFi",
        logo: SoFiLogo,
        descriptionMain:
          "This option is ideal for the investors who want a self-managed portfolio with occasional access to a financial advisor.",
        description:
          "Manifest has carefully reviewed your options and recommends Robinhood for its simple, low-cost investment solutions and trusted reputation in the financial industry.",
        hereIsWhy: [
          {
            icon: <IconBenefit color="dark" size="large" />,
            text: "SoFi offers a 1% match on IRA contributions",
          },
          {
            icon: <IconAdvisor color="dark" size="large" />,
            text: "Offers complimentary access to financial advisors",
          },
          {
            icon: <IconFree color="dark" size="large" />,
            text: "Commission-free trades and no account minimums",
          },
        ],
        standoutFeatures: [
          {
            heading: "IRA Match",
            description: "SoFi offers a 1% match on all IRA contributions, transfers, and rollovers, with no cap.",
          },
          {
            heading: "Commission-Free Trades",
            description:
              "SoFi allows you to trade stocks and ETFs without incurring commission fees, enabling cost-effective portfolio management.",
          },
        ],
        whoItsBestFor: [
          {
            heading: "Tech-Savvy Users",
            description: "Those who prefer a user-friendly, mobile-first platform for managing investments.",
          },
          {
            heading: "Investors Who Want Optionality",
            description:
              "SoFi does not offer mutual funds, which may not meet tahe needs of investors seeking a diversified portfolio.",
          },
        ],
        otherConsiderations: [
          {
            heading: "Limited Investment Options",
            description:
              "SoFi does not offer mutual funds or bonds, which may not meet the needs of investors seeking a diversified portfolio.",
          },
        ],
      };
    case "Vanguard":
      return {
        providerName: "Vanguard",
        descriptionMain: "Low-cost investing is ideal for buy-and-hold investors and retirement savers",
      };
    case "Wealthfront":
      return {
        providerName: "Wealthfront",
        descriptionMain:
          "Holistic financial advice and automated investment management that appeals to new and experienced investors",
      };
    case "Fidelity":
      return {
        providerName: "Fidelity",
        descriptionMain: "Very reputable provider within retirement industry",
      };
    case "Charles Schwab":
      return {
        providerName: "Charles Schwab",
        descriptionMain: "Comprehensive service offering",
      };

    default:
      return {};
  }
};
